import { Injectable, Provider } from '@angular/core';
import { ProductDetailThumbnailDialog } from 'projects/shared/lib/components/shared/product/detail/thumbnail-dialog/product-detail-thumbnail-dialog.model';
import { IProductDetailThumbnailDialogService, IProductDetailThumbnailDialogServiceToken } from 'shared/services/ui/dialogs/product-detail-thumbnail/product-detail-thumbnail-dialog-service.abstract';

@Injectable({
  providedIn: 'root',
}) export class ProductDetailThumbnailDialogService implements IProductDetailThumbnailDialogService {

  productDetailThumbnailDialogShow(
    productDetailThumbnailDialog: ProductDetailThumbnailDialog
  ) {
    return;
  }

}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ProductDetailThumbnailDialogServiceProvider: Provider[] = [
  { provide: IProductDetailThumbnailDialogServiceToken, useExisting: ProductDetailThumbnailDialogService }
];
